<template>
    <v-container fluid fill-height>

        <v-layout class="profile">


            <v-flex xs12>

                <v-toolbar flat color="white">
                    <v-toolbar-title>Информация о заказчике </v-toolbar-title>
                    <v-divider
                            class="mx-2"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>

                    <v-btn v-if="this.role == 'ROLE_CUSTOMER_ADMIN'" @click="editCustomer" color="info" dark class="mb-2"> Редактировать</v-btn>
                    <v-dialog v-if="this.role == 'ROLE_CUSTOMER_ADMIN'" v-model="customerDialog" max-width="900px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ customerFormTitle }}</span>
                            </v-card-title>
                            <v-alert
                                    :value="successAlert"
                                    dismissible
                                    type="success"
                            >
                                {{successText}}
                            </v-alert>
                            <v-alert
                                    :value="errorAlert"
                                    color="error"
                                    icon="warning"

                            >
                                {{errorText}}
                            </v-alert>
                            <v-form
                                    ref="customerForm"
                                    v-model="customerValid"
                                    lazy-validation
                            >
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm6 md6>
                                                <v-text-field v-model="customerItem.inn" :rules="innRules"  mask="##########" :counter="10" @blur="innRequest(customerItem.inn)" :error-messages="inputErrors.inn" required>
                                                    <template slot="label">
                                                        ИНН <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6 field-block style="height: 100%">
                                                <div v-if="customerItem.email.length >= 76 && customerItem.email.length < 100" class='max-length-block'>Осталось {{100 - customerItem.email.length}} символов</div>

                                                <v-text-field v-model="customerItem.email" :rules="emailRules" :error-messages="inputErrors.email" maxlength="100" required style="height: 100%">
                                                    <template slot="label">
                                                        Адрес элетронной почты <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6 field-block>
<!--                                                :class="!customerItem.name ? 'empty-filed' : ''" readonly-->
                                                <div v-if="customerItem.name.length >= 488 && customerItem.name.length < 512" class='max-length-block'>Осталось {{512 - customerItem.name.length}} символов</div>

                                                <v-textarea v-model="customerItem.name" rows="2" :rules="requiredRules512" :error-messages="inputErrors.name" maxlength="512" required>
                                                    <template slot="label">
                                                        Наименование <span class='error-file'>*</span>
                                                    </template>
                                                </v-textarea>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6>
                                                <v-text-field v-model="customerItem.phone" @focus="prefix='+7'" height="51" :prefix="(customerItem.phone != '' || prefix != '') ? '+7' : ''" mask="(###) ###-##-##" :rules="phoneRules" :counter="10" :error-messages="inputErrors.phone" required>
                                                    <template slot="label">
                                                        Телефон
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6 field-block>
                                                <div v-if="customerItem.address.length >= 488 && customerItem.address.length < 512" class='max-length-block'>Осталось {{512 - customerItem.address.length}} символов</div>

                                                <v-textarea
                                                        rows="2"
                                                        v-model="customerItem.address"
                                                        :rules="requiredRules512" :error-messages="inputErrors.address" maxlength="512" required
                                                >
                                                    <template slot="label">
                                                        Адрес (место нахождения) <span class='error-file'>*</span>
                                                    </template>
                                                </v-textarea>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6 field-block>
                                                <div v-if="customerItem.mailAddress.length >= 488 && customerItem.mailAddress.length < 512" class='max-length-block'>Осталось {{512 - customerItem.mailAddress.length}} символов</div>

                                                <v-textarea
                                                        rows="2"
                                                        v-model="customerItem.mailAddress"
                                                        :rules="requiredRules512" :error-messages="inputErrors.mailAddress" maxlength="512" required
                                                        readonly
                                                >
                                                    <template slot="label">
                                                        Почтовый адрес <span class='error-file'>*</span>
                                                    </template>
                                                </v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" flat @click="close">Отменить</v-btn>
                                    <v-btn color="success" flat @click="customerSave">Сохранить</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-toolbar>

                <v-container fluid grid-list-md customer-info>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">ИНН</p>
                            <div class="filed-block">{{customer_data.inn}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Адрес элетронной почты</p>
                            <div class="filed-block">{{customer_data.email}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Наименование</p>
                            <div class="filed-block-area">{{customer_data.name}}</div>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Телефон</p>
                            <div class="filed-block-area">{{ customer_data.phone ? '+7 ' + phoneNumberFormat(customer_data.phone) : ''}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Адрес (место нахождения)</p>
                            <div class="filed-block-area">{{customer_data.address}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Почтовый адрес</p>
                            <div class="filed-block-area">{{customer_data.mailAddress}}</div>
                        </v-flex>


                    </v-layout>
                </v-container>

                <v-divider style="margin: 30px 0;"></v-divider>

                <contactPersons></contactPersons>

                <v-divider style="margin: 30px 0;"></v-divider>

                <accountDetails></accountDetails>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import axios from 'axios'
    import accountDetails from "../components/account_details";
    import contactPersons from "../components/contactPersons";

    export default{
        components: {
            accountDetails, contactPersons
        },

        data(){
            return{
                backUrl: null,
                prefix: '',
                customerValid: true,
                requiredRules512: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => v.length <= 512 || 'Должно быть не более 512 символов'
                ],
                requiredRules200: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => v.length <= 200 || 'Должно быть не более 200 символов'
                ],
                innRules: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => (v && v.length == 10) || 'ИНН должен содержать 10 цифр',
                ],
                phoneRules: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => (v && v.length == 10) || 'Телефон должен содержать +7 ( 10 цифр)'
                ],
                emailRules: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => v.length <= 100 || 'Должно быть не более 100 символов',
                    v => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                    },
                ],
                customer_data: [],
                role:'',
                successText:'',
                errorText:'',
                errorAlert:false,
                successAlert:false,
                customerDialog: false,
                valid: true,
                token:'',
                user_customerId: '',
                customer_status: false,
                accountDetails_status: false,
                user_id: '',
                user_uuid: '',

                accountDetails_data: [],

                customerItem: {
                    customerId: this.user_customerId,
                    name: '',
                    inn: '',
                    address: '',
                    mailAddress: '',
                    phone: '',
                    email: '',
                },
                inputErrors:[],

                accountEditedItem: {
                    inn: '',
                    kpp: '',
                    account: '',
                    bic: '',
                    correspondentAccount: '',
                    bankName: '',
                    goalCode: ''
                },
                accountInputErrors:[],

            }
        },

        created () {
            this.token = localStorage.getItem('token');
            this.user_customerId = localStorage.getItem('user_customerId');
            this.user_id = localStorage.getItem('user_id');
            this.user_uuid = localStorage.getItem('user_uuid');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            if(this.user_customerId != "null"){
                this.customer_status = true
                this.getCustomer(this.user_customerId);
            }
        },

        watch: {
            customerDialog (val) {
                val || this.close()
            },
        },

        computed: {
            customerFormTitle () {
                return this.customer_status === false ? 'Добавить заказчика' : 'Редактировать заказчика'
            },
        },


        methods:{

            innRequest(inn){

                if(inn.length == 10){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/info/inn?value=' + inn,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            this.customerItem.name = this.changeQuotes(response.data.name)
                            this.customerItem.address = response.data.address
                            this.customerItem.mailAddress = response.data.postAddress
                        }
                    })
                }

            },

            editCustomer () {

                if(this.customer_status){
                    this.customerItem = Object.assign({}, this.customer_data)
                }
                this.customerDialog = true
            },

            getCustomer(id){

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers/' + id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data.accountDetailsId != null){
                        this.accountDetails_status = true
                        this.getAccountDetails()
                    }
                    this.customer_data = response.data
                })
            },

            getAccountDetails(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/accountDetails/',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.accountDetails_data = response.data
                })
            },

            customerSave(){
                this.inputErrors = ''
                if (this.$refs.customerForm.validate()) {
                    if(!this.customer_status){
                        axios({
                            method: 'post',
                            url: this.backUrl + '/api/customers',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: this.customerItem,
                        }).then(response => {
                            this.customer_data = JSON.parse(response.data.objectJson)
                            this.updateUser(this.customer_data.id)
                            this.inputErrors = ''
                            this.successText = 'Успешно добавлен'
                            this.successAlert = true

                            this.getCustomer(this.customer_data.id)
                            setTimeout(() => {
                                this.close()
                            }, 1500)
                        })
                        .catch(error => {
                            let errors = error.response.data.rows;
                            this.inputErrors = errors
                        });
                    }
                    else{
                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/customers',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.customer_data.id,
                                customerId: this.user_customerId,
                                uuid: this.customer_data.uuid,
                                name: this.customerItem.name,
                                inn: this.customerItem.inn,
                                address: this.customerItem.address,
                                mailAddress: this.customerItem.mailAddress,
                                contractPersons: this.customerItem.contractPersons,
                                phone: this.customerItem.phone,
                                email: this.customerItem.email,
                            },
                        }).then(response => {
                            this.customer_data = JSON.parse(response.data.objectJson)

                            this.inputErrors = ''
                            this.successText = 'Успешно изменен'
                            this.successAlert = true
                            this.getCustomer(this.customer_data.id)
                            setTimeout(() => {
                                this.close()
                            }, 1500)
                        })
                        .catch(error => {
                            let errors = error.response.data.rows;
                            this.inputErrors = errors
                        });
                    }
                }
            },

            updateUser(id)  {
                axios({
                    method: 'put',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        id: this.user_id,
                        uuid: this.user_uuid,
                        customerId: id,
                    },
                }).then(response => {
                    let user_customerId = JSON.parse(response.data.objectJson).customerId;
                    localStorage.setItem('user_customerId', user_customerId);
                })
            } ,

            close () {
                this.customerDialog = false
                setTimeout(() => {
                    this.successAlert = false
                    this.prefix = ''
                    this.successText = ''
                    this.errorText = ''
                    this.errorAlert = false
                    this.inputErrors = []
                }, 300)

            },

            phoneNumberFormat(item){
                if(item) {
                    let number = item.match(/(\d{3})(\d{3})(\d{2})(\d{2})/);
                    return "(" + number[1] + ") " + number[2] + "-" + number[3] + "-" + number[4];
                }
            },

            changeQuotes(val){
                return val.replace(/«|»|''|'/g,"\"");
            }

        }
    }
</script>
<style>
    .customer-info .theme--light.v-input--is-disabled input,.customer-info .theme--light.v-input--is-disabled textarea, .customer-info .theme--light.v-select .v-select__selection--disabled{
        color:rgba(0,0,0,.87)!important;
    }
    .profile .v-list__tile__action{
        width: 220px;
    }
    .v-divider--inset:not(.v-divider--vertical) {
        margin-left: 220px!important;
        max-width: calc(100% - 220px)!important;
    }
    .profile{
        background: #fff;
    }
</style>
